module.exports = __webpack_public_path__ + "img/selfie.d3e3f56c.svg";